import React from 'react';
import RenderEtherInfo from './RenderEtherInfo';

const RetrunEtherInfo = () => {
  return <RenderEtherInfo />;
};

export default RetrunEtherInfo;
